import { flow } from 'fp-ts/function';
import { filter, map, uniq } from 'lodash/fp';
import { createSelector } from 'reselect';
import { array, option, string } from 'fp-ts';
import { ProductServiceOrder, ServiceOrder, ServiceOrderType } from '@mews-commander/data-access';
import { composeProps, createPropsExtender } from '@mews/framework';
import { getServiceOrdersByIds } from '@mews-commander/legacy-entities/src/ducks/serviceOrders';
import { getOrderItemsByBillIds } from '@mews-commander/legacy-entities/src/ducks/orderItems';
import { getProductServiceOrdersByIds } from '@mews-commander/legacy-entities/src/ducks/productServiceOrders';
import { isProductServiceOrder } from '@mews-commander/legacy-entities/src/ducks/serviceOrderNew';

const getServiceOrderIdsByOrderItemIds = createSelector(getOrderItemsByBillIds, map('serviceOrderId'));

const getServiceOrderItemsByBillIds = composeProps(
    getServiceOrdersByIds,
    createPropsExtender('ids', getServiceOrderIdsByOrderItemIds)
);

export const getReservationIdsByBillIds = createSelector(
    getServiceOrderItemsByBillIds,
    flow(
        filter((serviceOrder: ServiceOrder) => serviceOrder.data.discriminator === ServiceOrderType.Reservation),
        map((serviceOrder: ServiceOrder) => serviceOrder.data.value.id),
        uniq
    )
);

const getProductServiceOrderIdsByBillIds = createSelector(
    getServiceOrderItemsByBillIds,
    flow(
        filter(
            (serviceOrder: ServiceOrder) => serviceOrder.data.discriminator === ServiceOrderType.ProductServiceOrder
        ),
        map<ServiceOrder, 'id'>('id'),
        uniq
    )
);

export const getProductServiceOrderAccountIds = flow(
    composeProps(getProductServiceOrdersByIds, createPropsExtender('ids', getProductServiceOrderIdsByBillIds)),
    map<ProductServiceOrder, 'ownerId'>('ownerId')
);

export const getLinkedReservationIdsByBillIds = createSelector(
    getServiceOrderItemsByBillIds,
    flow(
        array.filterMap((serviceOrder) =>
            isProductServiceOrder(serviceOrder) && !!serviceOrder.data.value.linkedReservationId
                ? option.some(serviceOrder.data.value.linkedReservationId)
                : option.none
        ),
        array.uniq(string.Eq)
    )
);
